import React from "react";
import Testimonials from "../home/Testimonials";

const ListTestimonials = () => {
  return <Testimonials />;
};

export default ListTestimonials;
